/**
 * Application version
 * @since 2026-01-17
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

export const APP_VERSION = "V20260721";
